import * as Cookies from 'js-cookie';
import 'slick-carousel';
import { commonSlickOptions } from './slick_config.js';
import { calcSlideWidth, setLinkCardWidth } from './slick_utils.js';
import {
  getMeta, getRailsEnv, getSilverEggDomain, getAigentCookieId,
  correlationTypes, pageKinds, determinePageKind, determinePlatformKind, determineSpecId
} from './aigent_common.js';

// ===== jQuery即座実行関数 =====
// NOTE: jQuery依存: slick-carouselライブラリの依存関係のため
(function($) {
  // ===== 定数定義 =====
  const TIMEOUT_DELAYS = {
    NOTIFICATION_TIMEOUT: 1000,  // 画像ビーコン送信のタイムアウト: 1秒（ユーザー待機時間の上限）
    RESIZE_DEBOUNCE: 200,        // リサイズデバウンス: 200ms
  };

  // ===== ユーティリティ関数 =====

  /**
   * おすすめアイテムをDOMに表示（トップページ用）
   * @param {HTMLElement} parentElement - 親要素（ul）
   * @param {Object} item - おすすめアイテムのデータ
   */
  function displayRecommendation(parentElement, item) {
    if (!parentElement) return;

    const li = document.createElement('li');
    li.className = 'm_linkCard';
    parentElement.appendChild(li);

    const a = document.createElement('a');
    a.href = item.ct_url;
    a.dataset.prodId = item._id;
    li.appendChild(a);

    // figure > img
    const figure = document.createElement('figure');
    figure.className = 'img';
    a.appendChild(figure);

    const img = document.createElement('img');
    img.className = 'card_slide_img';
    img.src = item.img_url;
    figure.appendChild(img);

    // div > p
    const div = document.createElement('div');
    div.className = 'txtWrap';
    a.appendChild(div);

    renderTags(div, item.desc);
    renderTitle(div, item.title);
  }

  /**
   * おすすめアイテムをDOMに表示（動画詳細ページ用）
   * @param {HTMLElement} parentElement - 親要素（ul）
   * @param {Object} item - おすすめアイテムのデータ
   */
  function displayMovieDetailRecommendation(parentElement, item) {
    console.info('[aigent.js] displayMovieDetailRecommendation()');
    console.assert(parentElement, '[aigent.js] parentElement is not found.');
    if (!parentElement) return;

    const li = document.createElement('li');
    li.className = 'recommended_video';
    parentElement.appendChild(li);

    const a = document.createElement('a');
    a.href = item.ct_url;
    a.dataset.prodId = item._id;  // Click Tracking用にContent IDを設定
    li.appendChild(a);

    // recommended_video_img
    const imgDiv = document.createElement('div');
    imgDiv.className = 'recommended_video_img';
    a.appendChild(imgDiv);

    const img = document.createElement('img');
    img.src = item.img_url;
    img.alt = item.title;
    imgDiv.appendChild(img);

    // recommended_video_txt
    const txtDiv = document.createElement('div');
    txtDiv.className = 'recommended_video_txt';
    a.appendChild(txtDiv);

    // txtWrap
    const txtWrapDiv = document.createElement('div');
    txtWrapDiv.className = 'txtWrap';
    txtDiv.appendChild(txtWrapDiv);

    renderMovieDetailTags(txtWrapDiv, item.desc);
    renderMovieDetailTitle(txtWrapDiv, item.title);
  }

  /**
   * タグ文字列を解析してタグ要素を表示
   * @param {HTMLElement} container - タグを表示するコンテナ
   * @param {string} desc - タグ文字列（空白区切り）
   */
  function renderTags(container, desc) {
    const tags = desc?.split(/\s+/)?.filter(tag => Boolean(tag)) || [];

    for (const tag of tags) {
      if (tag === 'PR') {
        renderPRTag(container);
      } else {
        renderPlanTag(container, tag);
      }
    }
  }

  /**
   * タグ文字列を解析してタグ要素を表示（動画詳細ページ用）
   * @param {HTMLElement} container - タグを表示するコンテナ
   * @param {string} desc - タグ文字列（空白区切り）
   */
  function renderMovieDetailTags(container, desc) {
    const tags = desc?.split(/\s+/)?.filter(tag => Boolean(tag)) || [];

    for (const tag of tags) {
      if (tag === 'PR') {
        renderMovieDetailPRTag(container);
      } else {
        renderMovieDetailPlanTag(container, tag);
      }
    }
  }

  /**
   * PRタグを表示
   * @param {HTMLElement} container - タグを表示するコンテナ
   */
  function renderPRTag(container) {
    const prTag = document.createElement('p');
    prTag.className = 'cat pr';
    prTag.innerText = 'PR';
    container.appendChild(prTag);
  }

  /**
   * PRタグを表示（動画詳細ページ用）
   * @param {HTMLElement} container - タグを表示するコンテナ
   */
  function renderMovieDetailPRTag(container) {
    const prTag = document.createElement('p');
    prTag.className = 'drvideo_tag_pr page_drvideo_tag';
    prTag.innerText = 'PR';
    container.appendChild(prTag);
  }

  /**
   * プランタグを表示（プレミアム、みんプレ限定、スペシャル、無料）
   * @param {HTMLElement} container - タグを表示するコンテナ
   * @param {string} tag - プラン名
   */
  function renderPlanTag(container, tag) {
    const planClassNameMap = {
      プレミアム: 'prem',
      みんプレ限定: 'min_prem',
      スペシャル: 'sp',
      無料: 'free',
    };

    const planTag = document.createElement('p');
    planTag.className = `cat ${planClassNameMap[tag] || ''}`;
    planTag.innerText = tag;
    container.appendChild(planTag);
  }

  /**
   * プランタグを表示（動画詳細ページ用）
   * @param {HTMLElement} container - タグを表示するコンテナ
   * @param {string} tag - プラン名
   */
  function renderMovieDetailPlanTag(container, tag) {
    const planClassNameMap = {
      プレミアム: 'prem',
      みんプレ限定: 'min_prem',
      スペシャル: 'sp',
      無料: 'free',
    };

    const planTag = document.createElement('p');
    planTag.className = `drvideo_tag_${planClassNameMap[tag] || 'free'} page_drvideo_tag`;
    planTag.innerText = tag;
    container.appendChild(planTag);
  }

  /**
   * タイトルを表示
   * @param {HTMLElement} container - タイトルを表示するコンテナ
   * @param {string} title - タイトル文字列
   */
  function renderTitle(container, title) {
    const pTitle = document.createElement('p');
    pTitle.className = 'txt';
    pTitle.innerText = title;
    container.appendChild(pTitle);
  }

  /**
   * タイトルを表示（動画詳細ページ用）
   * @param {HTMLElement} container - タイトルを表示するコンテナ
   * @param {string} title - タイトル文字列
   */
  function renderMovieDetailTitle(container, title) {
    const pTitle = document.createElement('p');
    pTitle.className = 'txt';
    pTitle.innerText = title;
    container.appendChild(pTitle);
  }

  /**
   * クリック通知をSilverEggに送信（画像ビーコン方式）
   * タイムアウト処理付きで、ユーザビリティを優先
   * @param {Event} event - クリックイベント
   * @param {Object} trackingData - トラッキングデータ
   * @returns {Promise} 通知完了を待つPromise
   */
  function notifyRecommendationClicked(event, trackingData) {
    const prod = event.currentTarget.dataset.prodId;
    const { rqid, spec, merch, cookie } = trackingData;
    const remoteDomain = getSilverEggDomain();
    const baseUrl = `https://${remoteDomain}/pycre5/jsonp/click`;
    const queryParams = {
      prod, merch, spec, cookie, cref: rqid,
    };
    const url = `${baseUrl}?${new URLSearchParams(queryParams).toString()}`;
    console.info(`[aigent.js] notifyRecommendationClicked() url: ${url}`);

    // 画像ビーコン方式で通知送信（Promise化）
    const imagePromise = new Promise((resolve) => {
      const img = new window.Image();
      img.onload = () => {
        console.info('[aigent.js] Click notification sent successfully');
        resolve();
      };
      img.onerror = (error) => {
        console.error('[aigent.js] Failed to send click notification:', error);
        // エラーでもresolveしてページ遷移を継続（ユーザビリティ優先）
        resolve();
      };
      img.src = url;
    });

    // タイムアウト処理（ユーザー待機時間の上限）
    const timeoutPromise = new Promise((resolve) => {
      setTimeout(() => {
        console.warn('[aigent.js] Notification timeout, proceeding anyway');
        resolve();
      }, TIMEOUT_DELAYS.NOTIFICATION_TIMEOUT);
    });

    // どちらかが完了したら終了（Promise.race）
    return Promise.race([imagePromise, timeoutPromise]);
  }

  /**
   * おすすめアイテムのクリックイベントハンドラーを設定
   * 通知送信完了後にページ遷移を実行
   * @param {HTMLElement} container - おすすめアイテムのコンテナ
   * @param {Object} trackingData - トラッキングデータ
   */
  function setupClickHandlers(container, trackingData) {
    const links = container.querySelectorAll('li > a');
    for (const link of links) {
      link.addEventListener('click', async (event) => {
        event.preventDefault(); // ページ遷移の一時的な無効化

        // リンク要素とhrefの取得（安全な方法）
        const linkElement = event.currentTarget;
        const href = linkElement?.href;

        if (!linkElement || !href) {
          console.error('[aigent.js] Invalid link element or no href found:', linkElement);
          return;
        }

        try {
          // 通知の実行〜完了を待つ
          await notifyRecommendationClicked(event, trackingData);
          console.info('[aigent.js] Notification completed, proceeding with navigation');

          // 通知完了後にページ遷移を再開
          window.location.href = href;
        } catch (error) {
          console.error('[aigent.js] Notification failed, but proceeding with navigation:', error);

          // エラーが発生してもページ遷移は実行
          window.location.href = href;
        }
      });
    }
  }

  /**
   * スライドカルーセルの初期化とレイアウト調整
   * リサイズ、メニュー開閉時の再調整も含む
   */
  function initializeContentSlides() {
    let slideWidth;
    function applySlideWidth() {
      slideWidth = calcSlideWidth();
      setLinkCardWidth('.js_aigent_slide', slideWidth);
    }

    applySlideWidth();

    const recommendationSection = document.querySelector('section#ai_recommendation');
    if (!recommendationSection) {
      console.warn('[aigent.js] recommendation section not found');
      return;
    }

    const slideContainer = recommendationSection.querySelector('.js_aigent_slide');
    if (!slideContainer) {
      console.warn('[aigent.js] .js_aigent_slide not found, skipping slick initialization');
      return;
    }

    // 新しいslickを初期化（jQuery依存のため$(slideContainer)を使用）
    $(slideContainer).slick(commonSlickOptions);

    /**
     * スライドレイアウトの再調整
     * 幅の再計算とslickの位置調整を実行
     */
    function refreshSlideLayout() {
      applySlideWidth();
      $(slideContainer).find('.slick-slide').css('width', slideWidth + 'px');
      $(slideContainer).slick('setPosition');
    }

    // window.onload時の再初期化（画像読み込み完了後）
    window.addEventListener('load', () => {
      refreshSlideLayout();
    });

    // リサイズ時の再初期化（デバウンス処理付き）
    let resizeTimer = null;
    window.addEventListener('resize', () => {
      refreshSlideLayout();        // 即座に実行
      clearTimeout(resizeTimer);   // 前のタイマーをキャンセル
      resizeTimer = setTimeout(() => {
        refreshSlideLayout();      // 200ms後に再実行（最終調整）
      }, TIMEOUT_DELAYS.RESIZE_DEBOUNCE);
    });

    // メニュー開閉時の再初期化（レイアウト変更後）
    const menuButtons = document.querySelectorAll('#gheader .gnavBtn, #gsideMenu .menuBtn, .sideNavBg');
    let transitionListener = null; // メモリリーク防止: イベントリスナーの重複を防ぐための参照保持

    menuButtons.forEach(button => {
      button.addEventListener('click', () => {
        const mainContents = document.getElementById('mainContents');

        // メモリリーク防止: 既存のリスナーを削除してから新しいリスナーを追加
        if (transitionListener) {
          mainContents.removeEventListener('transitionend', transitionListener);
        }

        // 新しいリスナーを追加
        transitionListener = () => {
          refreshSlideLayout();
        };
        mainContents.addEventListener('transitionend', transitionListener);
      });
    });

    // ページ離脱時のクリーンアップ: メモリリーク防止のためのリソース解放
    window.addEventListener('beforeunload', () => {
      if (transitionListener) {
        const mainContents = document.getElementById('mainContents');
        mainContents?.removeEventListener('transitionend', transitionListener);
      }
      if (resizeTimer) {
        clearTimeout(resizeTimer);
      }
    });
  }

  /**
   * ===== トップページ用 SilverEgg APIコールバック =====
   * SilverEgg APIからのおすすめを受け取り、トップページのDOMに反映
   * NOTE: slick-carouselによるスライダーUIを初期化
   */
  window.recommendationRequestCallbackForTopPage = ((recommendations) => {
    // データの検証と抽出
    const { items, rqid, spec, merch, cookie } = recommendations;

    console.assert(items?.length, '[aigent.js] recommendation items are empty.');
    if (!items?.length) return;
    // トップページのおすすめセクション
    const ul = document.querySelector('section#ai_recommendation > div > ul');
    console.assert(ul, '[aigent.js] the recommendation section ul not found.');
    if (!ul) return;

    for (const item of items) {
      // items: [ [{ title: 'タイトル', ...}, true], ...]
      displayRecommendation(ul, item[0]);
    }

    // クリックイベントの設定
    setupClickHandlers(ul, { rqid, spec, merch, cookie });

    // jQuery ready後にslick-carouselを初期化
    // NOTE: vanillaに書き換えると上手く動作しない
    $(() => { initializeContentSlides(); });
  });

  /**
   * ===== 動画詳細ページ用 SilverEgg APIコールバック =====
   * SilverEgg APIからのおすすめを受け取り、動画詳細ページのDOMに反映
   * NOTE: slick-carousel等は不要、リスト表示のみ
   */
  window.recommendationRequestCallbackForMovieDetail = ((recommendations) => {
    console.info('[aigent.js] recommendationRequestCallbackForMovieDetail()');
    // データの検証と抽出
    const { items, rqid, spec, merch, cookie } = recommendations;
    console.assert(items?.length, '[aigent.js] recommendation items are empty.');
    if (!items?.length) return;

    // 動画詳細ページのおすすめセクション
    const ul = document.querySelector('section#ai_recommendation > ul');
    console.assert(ul, '[aigent.js] the recommendation section ul for おすすめの動画 not found.');
    if (!ul) return;

    for (const item of items) {
      // items: [ [{ title: 'タイトル', ...}, true], ...]
      displayMovieDetailRecommendation(ul, item[0]);
    }
    // クリックイベントの設定
    setupClickHandlers(ul, { rqid, spec, merch, cookie });
  });

})(jQuery);

// ===== ページ読み込み時の初期化処理 =====
document.addEventListener('DOMContentLoaded', () => {
  const railsEnv = getRailsEnv();
  if (!railsEnv) return;

  const remoteDomain = getSilverEggDomain();
  const merchant = 'doctorbookac';
  const cookieId = getAigentCookieId();
  bakeAigentCookie(cookieId);
  if (!cookieId) return;

  const pageKind = determinePageKind();
  if (!pageKind) return;

  const platformKind = determinePlatformKind();
  // NOTE: 相関種別は暫定PurchaseOrder採用 (CV重視)
  const specId = determineSpecId(platformKind, pageKind, correlationTypes.PurchaseOrder);
  console.info(`[aigent.js] specId: ${specId}`);

  // ===== SilverEgg APIリクエスト発行: ページ種別ごとに分岐 =====
  const baseParams = [remoteDomain, merchant, specId, cookieId];
  if (pageKind === pageKinds.top) {
    appendJsonpScriptTag(...baseParams, 'recommendationRequestCallbackForTopPage', 12);
  } else if (pageKind === pageKinds.movieDetail) {
    appendJsonpScriptTag(...baseParams, 'recommendationRequestCallbackForMovieDetail', 8);
  } else {
    console.warn(`[aigent.js] unmatched pageKind: ${pageKind}`);
  }

  const AIGENT_COOKIE_EXPIRES_DAYS = 365; // Chromiumの保存上限(400日)を超えない範囲での実質的な永久値

  /**
   * Aigentクッキーを設定（1年間有効）
   * @param {string} value - クッキー値
   * @param {string} name - クッキー名（デフォルト: aigent_cookie_id）
   * expires: [chrome] The limit MUST NOT be greater than 400 days (since 2022-08) [safari] 7 days
   * secure: Either true or false, indicating if the cookie transmission requires a secure protocol (https)
   * sameSite: [None, Lax, Strict]
   */
  function bakeAigentCookie(value, name = 'aigent_cookie_id') {
    if (!value) return;

    // write (or re-write) the cookie with new expires
    // 有効期限: 365日（chrome最大400日/safari最大7日）
    // HTTPSのみ送信
    // クロスサイト制御
    const options = { expires: AIGENT_COOKIE_EXPIRES_DAYS, secure: true, sameSite: 'Lax' };
    Cookies.set(name, value, options);
  }

  /**
   * SilverEgg APIのリクエストURLを生成
   * @param {string} domain - SilverEggのドメイン
   * @param {string} merchant - マーチャントID
   * @param {string} spec
   * @param {string} cookie - クッキーID
   * @param {string} callbackName - コールバック関数名
   * @param {number} num - 取得件数
   * @returns {string} JSONPリクエストURL
   */
  function recommendRequestUrl(domain, merchant, spec, cookie, callbackName, num) {
    const baseUrl = `https://${domain}/pycre5/jsonp/recommend`;
    const queryParams = { merch: merchant, spec, num, cookie, callback: callbackName };

    // 動画詳細ページの場合、prodとcustパラメータを追加
    const pageKind = determinePageKind();
    console.info(`[aigent.js] pageKind: ${pageKind}`);
    if (pageKind === pageKinds.movieDetail) {
      const additionalParams = {
        prod: getMeta('aigent_prod'),  // prod(アイテムID)にContentIDを設定
        cust: getAigentCookieId(),     // cust(ユーザID)にCookieID(暗号化ユーザID)と同値を設定
      };
      Object.assign(queryParams, additionalParams);
    }

    // queryParamsの各値が無効なら警告を出力
    for (const [key, value] of Object.entries(queryParams)) {
      if (!value) console.warn(`[aigent.js] Invalid value detected in queryParams: ${key} =`, value);
    }

    return `${baseUrl}?${new URLSearchParams(queryParams).toString()}`;
  }

  /**
   * JSONPスクリプトタグを動的に作成してDOMに追加
   * @param {string} domain - SilverEggのドメイン
   * @param {string} merchant - マーチャントID
   * @param {string} spec
   * @param {string} cookie - クッキーID
   * @param {string} callbackName - コールバック関数名
   * @param {number} num - 取得件数（デフォルト: 12）
   */
  function appendJsonpScriptTag(domain, merchant, spec, cookie, callbackName, num = 12) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = recommendRequestUrl(domain, merchant, spec, cookie, callbackName, num);
    document.body.after(script);
  }
});
